import { render, staticRenderFns } from "./PageHeaderCount.vue?vue&type=template&id=6e6ebbaa&scoped=true"
import script from "./PageHeaderCount.vue?vue&type=script&lang=js"
export * from "./PageHeaderCount.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderCount.vue?vue&type=style&index=0&id=6e6ebbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ebbaa",
  null
  
)

export default component.exports